<!--Control Background Image opacity by changing the a value of bg-[rgba(255,255,255,0.8)]-->
<div
  class="
  min-h-screen
  h-full
  w-full
  bg-[rgb(255,255,255)]
  bg-blend-overlay
  bg-fixed
  bg-no-repeat
  bg-[center_bottom_5rem]
  bg-size-[90%_auto]
  md:bg-size-[50%_auto]
  xl:bg-size-[30%_auto]">
  <div class="container mx-auto">
    <app-header-image [imageUrl]=headerImageUrl() />
    <app-header-navigation />
    <router-outlet />
  </div>
</div>
